import React, { memo, useState, useEffect } from 'react'
import styles from './index.module.scss'
import classnames from 'classnames'
import PolicyApi from '@/services/apis/setting/index'
import {
  PolicyTypeEnum,
  PolicyConditionTypeEnum,
  PolicyItemModel,
  PolicyFromTypeEnum,
  PolicyToTypeEnum,
  PolicyActTypeEnum,
  PolicyAuditStateEnum,
  FromAccountModel,
} from '@/constants/enum'
import { useTranslation } from '@/services/i18n'
import { Select, Table, Button } from 'antd'
import { getconditionText, getAuditStateText } from '@/utils/setting'
import MyTable from '@/components/Table'
import MyModal from '@/components/Modal'
import Shape2 from '@/assets/images/shape2.png'
import { debounce } from 'lodash'
import { AuditInfoModel } from '@/services/apis/policy/model'
import ApprovalFlow from '@/views/Application/components/Approval'
import StrategyDetailModal from '@/components/StrategyDetailModal'
const { Column, ColumnGroup } = Table

const strategy = memo(() => {
  const { t } = useTranslation()
  // select中的属性
  const options = [
    {
      label: t('policy.allType'),
      value: '',
    },
    {
      label: t('policy.ValueGreaterThan'),
      value: 1,
    },
    {
      label: t('policy.ValueLessThan'),
      value: 2,
    },
    {
      label: t('policy.NumberGreaterThan'),
      value: 3,
    },
    {
      label: t('policy.NumberLessThan'),
      value: 4,
    },
  ]
  const options2 = [
    {
      label: t('record.allStatus'),
      value: '',
    },
    {
      label: t('policy.Valid'),
      value: 1,
    },
    {
      label: t('policy.Invalid'),
      value: 0,
    },
  ]
  // type判断策略
  const [type, setType] = useState(PolicyTypeEnum.SEND)
  const [loading, setLoading] = useState(false)
  const [conditionType, setConditionType] = useState<PolicyConditionTypeEnum | string>('')
  const [activeStatus, setActiveStatus] = useState<0 | 1 | ''>('')
  const [normalList, setNormalList] = useState<Partial<PolicyItemModel>[]>([])

  // 获取数据
  const getList = async () => {
    setLoading(true)
    const res = await PolicyApi.getPolicyList(type, conditionType, activeStatus)
    setLoading(false)
    if (res.success) {
      setNormalList(res.data)
    }
  }
  // 改变tab
  const handleChangeTab = (item: PolicyTypeEnum) => {
    setConditionType('')
    setActiveStatus('')
    setType(item)
  }
  // 改变select
  const handleChangeSelect = (value: PolicyConditionTypeEnum | string | number, type?: string) => {
    type === 'ConditionType' ? setConditionType(value) : setActiveStatus(value as '' | 0 | 1)
  }
  // 判断type
  const isWeb3 = type === PolicyTypeEnum.WEB3
  const isSend = type === PolicyTypeEnum.SEND

  const renderTransValue = (record: PolicyItemModel) => {
    return <div>{getconditionText(record)}</div>
  }
  const renderTransfer = (record: PolicyItemModel) => {
    return (
      <div>
        {record.initiatorIsAny === 1
          ? t('policy.allUser')
          : record.initiatorUserDtoList?.map(item => {
              return <p key={item?.userKey}>{item.userName}</p>
            })}
      </div>
    )
  }
  function showFromAddress(record: FromAccountModel[]) {
    MyModal.info({
      icon: null,
      footer: null,
      title: 'From',
      centered: true,
      content: (
        <div style={{ maxHeight: '600px', overflowY: 'auto', paddingLeft: '10px' }}>
          {record.map((item, index) => {
            const length = record.length
            return (
              <span key={item.fromAccountKey} style={{ marginRight: '10px' }}>
                {item.fromAccountName}
                {index !== length - 1 && <span style={{ marginLeft: '5px' }}>/</span>}
              </span>
            )
          })}
        </div>
      ),
      closable: true,
    })
  }
  const renderFrom = (record: PolicyItemModel) => {
    if (record.fromType === PolicyFromTypeEnum.ANY) {
      return t('policy.any')
    } else if (!record.fromAccountIsAny && record.fromAccountDtoList) {
      const formAddress = record.fromAccountDtoList
      const length = formAddress.length
      return formAddress?.slice(0, 3).map((item, index) => {
        return (
          <div key={item.fromAccountKey}>
            <div style={{ marginBottom: '5px' }}>{item.fromAccountName}</div>
            {length > 3 && index === 2 && (
              <Button
                type="link"
                onClick={() => showFromAddress(record.fromAccountDtoList!!)}
                style={{ fontWeight: 'bold' }}
              >
                {t('policy.all')}
              </Button>
            )}
          </div>
        )
      })
    } else {
      return t('policy.allWallet')
    }
  }
  const showToAddress = (record: string[]) => {
    MyModal.info({
      icon: null,
      footer: null,
      title: 'To',
      centered: true,
      content: (
        <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
          {record.map((item, index) => {
            return (
              <div style={{ marginLeft: '10px', marginBottom: '5px' }} key={index}>
                {item}
              </div>
            )
          })}
        </div>
      ),
      closable: true,
    })
  }
  const handleRenderTo = (record: PolicyItemModel) => {
    if (type === PolicyTypeEnum.WEB3 && record.toAddressList) {
      const toAddress = record.toAddressList
      const length = toAddress.length
      return toAddress.slice(0, 3).map((item, index) => {
        return (
          <div key={index}>
            <div style={{ marginBottom: '5px' }}>{item}</div>
            {length > 3 && index === 2 && (
              <Button
                type="link"
                onClick={() => showToAddress(record.toAddressList!!)}
                style={{ fontWeight: 'bold' }}
              >
                {t('policy.all')}
              </Button>
            )}
          </div>
        )
      })
    }
    if (record.toType === PolicyToTypeEnum.ANY) {
      return t('policy.any')
    } else if (record.toType === PolicyToTypeEnum.UNKNOWN) {
      return t('policy.unknown')
    } else if (record.toType === PolicyToTypeEnum.VAULT) {
      return record.toAccountIsAny === 1 ? (
        <div>{t('policy.allWallet')}</div>
      ) : (
        record.toAccountDtoList?.map((item, index) => {
          return <div key={index}>{item.toAccountName}</div>
        })
      )
    } else {
      return record.toAccountIsAny === 1
        ? t('policy.allWhite')
        : record.toAccountDtoList?.map(item => {
            return <div key={item.toAccountKey}>{item.toAccountName}</div>
          })
    }
  }
  const renderTo = (record: PolicyItemModel) => {
    return handleRenderTo(record)
  }
  const renderAction = (record: PolicyItemModel) => {
    return record.act === PolicyActTypeEnum.ALLOW ? t('policy.actionRule') : t('policy.actionNone')
  }
  const [flowMap, setFlowMap] = useState<{
    [key: string]: AuditInfoModel
  }>({})

  const renderAudit = (record: PolicyItemModel) => {
    const auditInfo = flowMap[record.modifyKey]

    return (
      <div className={styles.stateContainer}>
        {auditInfo ? (
          <ApprovalFlow
            auditStatus={record.auditStatus as any}
            flow={auditInfo}
            renderChildren={() => (
              <div>
                {getAuditStateText(record.auditStatus as PolicyAuditStateEnum, record.applyType)}
              </div>
            )}
          />
        ) : (
          <div>
            {getAuditStateText(record.auditStatus as PolicyAuditStateEnum, record.applyType)}
          </div>
        )}
      </div>
    )
  }

  const renderEffect = (record: PolicyItemModel) => {
    return record.activeStatus === 1 ? t('policy.valid') : t('policy.invalid')
  }
  const showDetail = (record: PolicyItemModel) => {
    MyModal.info({
      footer: null,
      title: renderDetailTitle(),
      content: <StrategyDetailModal record={record} type={type} />,
      closable: true,
    })
  }
  const renderOpeation = (record: PolicyItemModel) => {
    return (
      <Button
        type="link"
        onClick={() => showDetail(record)}
        style={{ marginTop: '-5px', fontWeight: 'bold' }}
      >
        {t('policy.detail')}
      </Button>
    )
  }
  const renderDetailTitle = () => {
    let titleText = ''
    if (isWeb3) {
      titleText = t('policy.web3Detail')
    } else if (isSend) {
      titleText = t('policy.sendDetail')
    } else {
      titleText = t('policy.mpcDetail')
    }
    return (
      <div className={styles.detailText}>
        <span>{titleText}</span>
      </div>
    )
  }

  useEffect(() => {
    getList()
  }, [type, conditionType, activeStatus])
  const PolicyTypeMap: { [key in PolicyTypeEnum]: string } = {
    [PolicyTypeEnum.SEND]: t('policy.send'),
    [PolicyTypeEnum.MPC_SIGN]: 'MPC Sign',
    [PolicyTypeEnum.WEB3]: t('policy.web3'),
  }

  const handleApproval = async (record: PolicyItemModel) => {
    if (!flowMap[record.modifyKey] && record.auditStatus !== PolicyAuditStateEnum.INIT) {
      const res = await PolicyApi.getAuditorInfoByModifyKey(record.modifyKey)
      if (res.success) {
        setFlowMap({
          ...flowMap,
          [record.modifyKey]: res.data,
        })
      }
    }
  }
  const deHandleApproval = debounce(handleApproval, 1000)
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {Object.values(PolicyTypeEnum).map(item => {
          return (
            <span
              key={item}
              className={classnames(styles.titlePannel, { [styles.active]: type === item })}
              onClick={() => handleChangeTab(item)}
            >
              {PolicyTypeMap[item]}
            </span>
          )
        })}
      </div>
      <div className={styles.options}>
        {isSend && (
          <Select
            defaultValue={''}
            style={{ width: 200, marginRight: '15px' }}
            options={options}
            onChange={value => handleChangeSelect(value, 'ConditionType')}
            suffixIcon={<img src={Shape2} alt="" style={{ width: '12px', height: 'auto' }}></img>}
          ></Select>
        )}
        <Select
          defaultValue={''}
          style={{ width: 200 }}
          options={options2}
          onChange={value => handleChangeSelect(value)}
          suffixIcon={<img src={Shape2} alt="" style={{ width: '12px', height: 'auto' }}></img>}
        ></Select>
      </div>
      {type === PolicyTypeEnum.MPC_SIGN && (
        <MyTable
          loading={loading}
          dataSource={normalList}
          pagination={{ hideOnSinglePage: true, pageSize: normalList.length }}
          rowKey="gmtCreate"
          style={{ height: 100 }}
          onRow={(record: PolicyItemModel) => {
            return {
              onMouseEnter: e => {
                deHandleApproval(record)
              },
            }
          }}
        >
          <ColumnGroup title={t('policy.condition')} align="left">
            <Column title={t('policy.transfer')} render={renderTransfer} />
            <Column title="From" render={renderFrom} />
          </ColumnGroup>
          <Column title={t('policy.action')} render={renderAction} rowSpan={1} />
          <Column title={t('policy.auditState')} render={renderAudit} rowSpan={1} />
          <Column
            title={t('policy.effectiveState')}
            render={renderEffect}
            rowSpan={1}
            width={140}
          />
          <Column title={t('policy.priority')} dataIndex="priority" rowSpan={1} />
          <Column title={t('common.operation')} render={renderOpeation} rowSpan={1} />
        </MyTable>
      )}
      {type === PolicyTypeEnum.SEND && (
        <MyTable
          loading={loading}
          dataSource={normalList}
          pagination={{ hideOnSinglePage: true, pageSize: normalList.length }}
          rowKey="gmtCreate"
          style={{ height: 100 }}
          onRow={(record: PolicyItemModel) => {
            return {
              onMouseEnter: e => {
                deHandleApproval(record)
              },
            }
          }}
        >
          <ColumnGroup title={t('policy.condition')} align="left">
            <Column title={t('policy.valueAndNumber')} render={renderTransValue} />
            <Column title={t('policy.transfer')} render={renderTransfer} />
            <Column title="From" render={renderFrom} />
            <Column title="To" render={renderTo} />
          </ColumnGroup>
          <Column title={t('policy.action')} render={renderAction} rowSpan={1} />
          <Column title={t('policy.auditState')} render={renderAudit} rowSpan={1} />
          <Column title={t('policy.effectiveState')} render={renderEffect} rowSpan={1} />
          <Column title={t('policy.priority')} dataIndex="priority" rowSpan={1} />
          <Column title={t('common.operation')} render={renderOpeation} rowSpan={1} />
        </MyTable>
      )}
      {type === PolicyTypeEnum.WEB3 && (
        <MyTable
          loading={loading}
          dataSource={normalList}
          pagination={{ hideOnSinglePage: true, pageSize: normalList.length }}
          rowKey="gmtCreate"
          style={{ height: 100 }}
          onRow={(record: PolicyItemModel) => {
            return {
              onMouseEnter: e => {
                deHandleApproval(record)
              },
            }
          }}
        >
          <ColumnGroup title={t('policy.condition')} align="left">
            <Column title={t('policy.transfer')} render={renderTransfer} />
            <Column title="From" render={renderFrom} />
            <Column title="To" render={renderTo} />
          </ColumnGroup>
          <Column title={t('policy.action')} render={renderAction} rowSpan={1} />
          <Column title={t('policy.auditState')} render={renderAudit} rowSpan={1} />
          <Column title={t('policy.effectiveState')} render={renderEffect} rowSpan={1} />
          <Column title={t('policy.priority')} dataIndex="priority" rowSpan={1} />
          <Column title={t('common.operation')} render={renderOpeation} rowSpan={1} />
        </MyTable>
      )}
    </div>
  )
})

export default strategy
